import type { Settlement } from '../engine/map/settlement';
import {
    addPerson,
    getFoodPerPersonPerHour,
    getHouseCapacity,
    getPopulationCount,
} from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';

export function runPopulationTick(settlement: Settlement): boolean {
    const config = getGameConfig();
    const growthPerTick = config.production.populationGrowthPerTick;
    const capacity = settlement.houses.length * getHouseCapacity();
    let population = getPopulationCount(settlement);
    if (population >= capacity) {
        if (settlement.production.population.growth !== 0) {
            settlement.production.population.growth = 0;
            return true;
        }
        return false;
    }

    const totalHouseFood = settlement.houses.reduce((sum, house) => sum + house.storage.food, 0);
    const foodPerHour = getFoodPerPersonPerHour(config);
    const foodRequirement =
        population * settlement.production.population.houseFoodTargetHours * foodPerHour;
    const hasFoodBuffer = totalHouseFood >= foodRequirement;
    if (!hasFoodBuffer) {
        if (settlement.production.population.growth !== 0) {
            settlement.production.population.growth = 0;
            return true;
        }
        return false;
    }

    settlement.production.population.growth += growthPerTick;
    let changed = true;
    while (settlement.production.population.growth >= 1 && population + 1 <= capacity) {
        settlement.production.population.growth -= 1;
        const added = addPerson(settlement);
        if (!added) break;
        population += 1;
    }
    return changed;
}
